export enum FeatureFlags {
  stediClearinghouse = 'stediClearinghouse',
  teamChatHuddles = 'teamChatHuddles',
  telehealthHuddles = 'telehealthHuddles',
  reportSnapshots = 'reportSnapshots',
  claimRejectionsReport = 'claimRejectionsReport',
  serviceLineLevelBilling = 'serviceLineLevelBilling',
  /** Patient-record-level Claim Info (table, resolver, snapshots, UI). */
  patientRecordClaimInfo = 'patientRecordClaimInfo',
  turnOffTracks = 'turnOffTracks',
  memberships = 'memberships',
  aiReceptionist = 'aiReceptionist',
  clinicWidgets = 'clinicWidgets',
  creditCardInformationRequest = 'creditCardInformationRequest',
}

export enum FlagGroups {
  everyone = 'everyone',
  beta = 'beta',
  alpha = 'alpha',
  internal = 'internal',
}

export const flagGroupsArr = [
  {
    label: 'Internal',
    value: 'internal',
  },
  {
    label: 'Alpha',
    value: 'alpha',
  },
  {
    label: 'Beta',
    value: 'beta',
  },
  {
    label: 'Everyone',
    value: 'everyone',
  },
];
